export default __webpack_public_path__ + "static/media/qr-code-xclass.458da73d.svg";